var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29275 3.59961C7.29275 3.04732 7.74046 2.59961 8.29275 2.59961H11.706C12.2583 2.59961 12.706 3.04732 12.706 3.59961V4.14622H14.7999C15.3522 4.14622 15.7999 4.59394 15.7999 5.14622V6.46621H4.19995V5.14622C4.19995 4.59394 4.64767 4.14622 5.19995 4.14622H7.29275V3.59961ZM15.7999 7.23957H4.19995L4.90226 16.3695C4.94233 16.8905 5.37678 17.2928 5.89931 17.2928H14.1005C14.623 17.2928 15.0575 16.8905 15.0976 16.3695L15.7999 7.23957ZM8.06605 9.5594C7.63896 9.5594 7.29272 9.90563 7.29272 10.3327V14.1994C7.29272 14.6265 7.63896 14.9727 8.06605 14.9727C8.49315 14.9727 8.83938 14.6265 8.83938 14.1994V10.3327C8.83938 9.90563 8.49315 9.5594 8.06605 9.5594ZM11.1599 10.3327C11.1599 9.90561 11.5061 9.55938 11.9332 9.55938C12.3603 9.55938 12.7066 9.90561 12.7066 10.3327V14.1993C12.7066 14.6264 12.3603 14.9727 11.9332 14.9727C11.5061 14.9727 11.1599 14.6264 11.1599 14.1993V10.3327Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.2d07dfa1b1c87461e521bbcc93a8b6fe.svg";
export { ForwardRef as ReactComponent };